import {IntermediatePart} from "../../intermediatePart";
import {Shower} from "../../parts/shower";
import {Vanity} from "../../parts/vanity";
import {getCurrentRoomType} from "../../../../appLayout";
import {LOOK_ROOM_TYPES} from "../../constants";

const splitWallPartIds = ["left_wall", "right_wall", "split_wall", "left_wall_splitter", "ceiling_panels"];
const shouldCheckAdditionalPartsConditions = ["front_wall", "right_wall", "left_wall"];

export default class WallCommon extends IntermediatePart {

  constructor(props) {
    super(props);
  }

  getArrayOfConditions() {
    const conditions = super.getArrayOfConditions();
    const showerParent = this.getParent().layout.parts[Shower.id];
    if (this.partId !== "split_wall") { // on layout 11 we are moving the wall, so split wall is always on the same position
      const showerSize = showerParent ? showerParent.showerSize() : null;
      if (showerSize) {
        conditions.push({
          propName: "ShowerSize",
          propValue: showerSize
        })
      }
    }

    if (getCurrentRoomType(showerParent.layout) === LOOK_ROOM_TYPES.as && splitWallPartIds.every(partId => this.partId !== partId)) {
      const wallParent = this.getParent();
      if (wallParent && wallParent.splitWall) {
        conditions.push({
          propName: "SplitWallType",
          propValue: wallParent.getSplitWallType()
        })
      }
    }
    return conditions
  }

  getAdditionalPartsConditions(arrayOfConditions = []) {
    if (shouldCheckAdditionalPartsConditions.every(partId => this.partId !== partId)) {
      return arrayOfConditions
    }
    const layout = this.getParent().layout;
    if (!layout) {
      return arrayOfConditions
    }
    const vanityParent = layout.parts[Vanity.id];
    if (!vanityParent) {
      return arrayOfConditions
    }
    // if (!arrayOfConditions.some(condition => condition.propName === "VanitySize")) {
    //   const vanitySize = vanityParent.counterTopSize(this);
    //   if (vanitySize) {
    //     arrayOfConditions.push({
    //       propName: "VanitySize",
    //       propValue: vanitySize
    //     })
    //   }
    // }
    if (!arrayOfConditions.some(condition => condition.propName === "MirrorShape")) {
      const mirror = vanityParent.mirror;
      if (mirror && mirror.activeFeature && !mirror.disabled && mirror.activeFeature.metaData["MirrorShape"]) {
        arrayOfConditions.push({
          propName: "MirrorShape",
          propValue: mirror.activeFeature.metaData["MirrorShape"]
        })
      }
    }
    return arrayOfConditions
  }

}
